import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c9414c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-player-resources-diets-list" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box__headline" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Popis prehrane ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "box__list"
}
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "action" }
const _hoisted_8 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppPlayerResourcesDietsListFormLookupIndexVue = _resolveComponent("AppPlayerResourcesDietsListFormLookupIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.diets.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.diets, (diet) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: diet.id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(diet.content.name), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_AppPlayerResourcesDietsListFormLookupIndexVue, { diet: diet }, null, 8, ["diet"])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, " Nema podataka... "))
    ])
  ]))
}